// Reducers/studentReducer.js
const initialState = {
    profile: null,
    loading: true,
    error: null,
    updateSuccess: false,
    updateError: null,
    admissionLoading: false,
    admissionSuccess: false,
    admissionError: null,
    submissions: [],
    submissionsLoading: false,
    submissionsError: null,
};
  
export const studentReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_STUDENT_PROFILE_SUCCESS':
            return {
                ...state,
                profile: action.payload,
                loading: false,
            };
        case 'FETCH_STUDENT_PROFILE_FAILURE':
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case 'UPDATE_STUDENT_PROFILE_SUCCESS':
            return {
                ...state,
                updateSuccess: true,
                updateError: null,
            };
        case 'UPDATE_STUDENT_PROFILE_FAIL':
            return {
                ...state,
                updateError: action.payload,
                updateSuccess: false,
            };
        case 'CLEAR_UPDATE_STATE':
            return {
                ...state,
                updateSuccess: false,
                updateError: null,
            };
        case 'SUBMIT_ADMISSION_REQUEST':
            return {
                ...state,
                admissionLoading: true,
                admissionSuccess: false,
                admissionError: null,
            };
        case 'SUBMIT_ADMISSION_SUCCESS':
            return {
                ...state,
                admissionLoading: false,
                admissionSuccess: true,
                admissionError: null,
            };
        case 'SUBMIT_ADMISSION_FAILURE':
            return {
                ...state,
                admissionLoading: false,
                admissionSuccess: false,
                admissionError: action.payload,
            };
        case 'FETCH_MY_SUBMISSIONS_REQUEST':
            return {
                ...state,
                submissionsLoading: true,
                submissionsError: null,
            };
        case 'FETCH_MY_SUBMISSIONS_SUCCESS':
            return {
                ...state,
                submissionsLoading: false,
                submissions: action.payload,
            };
        case 'FETCH_MY_SUBMISSIONS_FAILURE':
            return {
                ...state,
                submissionsLoading: false,
                submissionsError: action.payload,
            };
        case 'UPDATE_ADMISSION_REQUEST':
            return {
                ...state,
                updateAdmissionLoading: true,
                updateAdmissionSuccess: false,
                updateAdmissionError: null,
            };
        case 'UPDATE_ADMISSION_SUCCESS':
            return {
                ...state,
                updateAdmissionLoading: false,
                updateAdmissionSuccess: true,
                updateAdmissionError: null,
            };
        case 'UPDATE_ADMISSION_FAILURE':
            return {
                ...state,
                updateAdmissionLoading: false,
                updateAdmissionSuccess: false,
                updateAdmissionError: action.payload,
            };
        default:
            return state;
    }
};
